import deWeb from '../locales/de/web.json';

/**
 * The statement e-mail ("E-Mail (sicherer Link)" on the Versand page) from ONE text source: the Versand page shows
 * exactly this as its preview and the server sends exactly this (apps/server/src/modules/billing.ts, POST
 * /statements/:id/send). Before 04.11.2026 the preview had its own Du text while the server wrote Sie. The mail always
 * goes out in German (like the statement PDF); the texts live in web.json `dispatchPage.mail`, `_du` variants follow
 * the account's Anrede (`defaults.tenantAddress`).
 */
export type StatementMailForm = 'du' | 'sie';
export type StatementMail = { subject: string; hello: string; text: string; button: string };

const M = deWeb.dispatchPage.mail as Record<string, string>;
const pick = (form: StatementMailForm, k: string) => (form === 'du' ? M[`${k}_du`] : undefined) ?? M[k]!;

/** `names`: the tenancy's contract parties as on the statement ("Julia Schneider, Max Schneider"); empty → "Guten Tag,". */
export function statementMail(form: StatementMailForm, names?: string): StatementMail {
  const n = names?.trim();
  return {
    subject: pick(form, 'subject'),
    hello: n ? pick(form, 'hello').replace(/\{\{\s*name\s*\}\}/g, n) : pick(form, 'helloNoName'),
    text: pick(form, 'body'),
    button: pick(form, 'button'),
  };
}
